/**
 * **Höchstens so lange warten** — danach mit dem Rückfall weitermachen.
 *
 * Gebaut für den **Start** (`AuthProvider`): Ein Netz, das annimmt und dann
 * schweigt, hielt den Logo-Schirm minutenlang stehen. Sauber offline war nie
 * das Problem — dort scheitert `fetch` sofort. Es ist das halbe WLAN, das
 * Hotel-Portal, der schwache Empfang: Die Verbindung steht, niemand bricht ab.
 *
 * **Es bricht nichts ab**, und das ist Absicht. Die Supabase-Anfrage lässt sich
 * von außen nicht stoppen; sie darf im Hintergrund fertig werden, und
 * `onAuthStateChange` nimmt ein spätes Ergebnis ohnehin an. Hier wird nur
 * aufgehört zu *warten*.
 *
 * **Bewusst nicht am `fetch` des Supabase-Clients:** Das träfe jede Anfrage,
 * auch das Hochladen großer Sync-Pakete, und schnitte dort mitten hinein. Die
 * Schranke gehört an den Start, nicht an den Transport.
 *
 * Ein **Wurf** wird durchgereicht, nicht in den Rückfall verwandelt: Ein Fehler
 * ist etwas anderes als ein Schweigen, und der Aufrufer soll ihn sehen.
 *
 * @example
 * const session = await withTimeout(getCurrentSession(), START_NETWORK_BUDGET, null)
 */
export function withTimeout<T>(promise: Promise<T>, ms: number, fallback: T): Promise<T> {
  let timer: ReturnType<typeof setTimeout>

  const frist = new Promise<T>(resolve => {
    timer = setTimeout(() => resolve(fallback), ms)
  })

  return Promise.race([promise, frist]).finally(() => clearTimeout(timer))
}
